import React from "react";
import { SvgIcon } from "@mui/material";
const TravelTimeIcon = ({ sx }) => (
    <SvgIcon viewBox="0 -5 100 50" sx={sx}>
        <path d="M24.8038 8.44977L23.8106 6.86073C23.281 6.33105 45.042 6.06621 55.9887 6C63.775 7.64201 71.4156 12.5548 74.2626 14.8059C91.0137 16.8584 92.1393 18.6461 94.258 20.1027C95.953 21.268 96.6416 23.8546 96.774 25.0023C96.774 25.532 96.6681 26.5913 96.2443 26.5913C95.8206 26.5913 95.7147 26.9003 95.7147 27.0548V28.1804C95.7147 28.8425 95.9795 28.7763 96.5092 28.7763C96.9329 28.7763 96.8623 28.997 96.774 29.1073L95.1188 30.7626H86.6439C86.0083 30.7626 85.9377 30.3212 85.9818 30.1005V26.7237C85.5404 24.9581 83.5453 21.4137 79.096 21.3607C74.6466 21.3078 72.6074 24.914 72.1439 26.7237V31.226C72.1439 31.8087 71.7467 31.8661 71.548 31.8219H38.2444C37.7147 31.8219 37.5382 31.4247 37.5161 31.226V26.7237C37.1188 24.9802 35.1988 21.4667 30.6965 21.3607C26.1942 21.2548 24.1858 25.1568 23.7444 27.121V30.5639C23.7444 31.0936 23.4796 31.226 23.3472 31.226H19.838C19.3084 31.226 19.3525 30.7846 19.4408 30.5639L16.9248 27.9155V23.6119L18.4476 22.5525V16.2626C20.7253 12.4489 23.6341 9.46499 24.8038 8.44977Z" />
        <path
            d="M23.7441 26.6581V30.6969H37.4496C37.4717 29.6817 37.5026 27.4527 37.4496 26.6581C37.3834 25.665 35.4633 21.2951 30.4313 21.2289C26.4058 21.1759 24.2959 24.8263 23.7441 26.6581Z"
            fill="#D9D9D9"
        />
        <path
            d="M72.21 26.6581V30.6969H85.9154C85.9375 29.6817 85.9684 27.4527 85.9154 26.6581C85.8492 25.665 83.9291 21.2951 78.8972 21.2289C74.8716 21.1759 72.7617 24.8263 72.21 26.6581Z"
            fill="#D9D9D9"
        />
        <path
            d="M9.97266 10.9658H20.4338"
            stroke="#6B6B6C"
            stroke-width="1.3242"
            stroke-linecap="round"
        />
        <path
            d="M9.17822 15.468L16.1965 15.468"
            stroke="#6B6B6C"
            stroke-width="1.3242"
            stroke-linecap="round"
        />
        <path
            d="M6 20.6324H16.726"
            stroke="#6B6B6C"
            stroke-width="1.3242"
            stroke-linecap="round"
        />
        <circle cx="30.5" cy="28.5" r="5.5" />
        <ellipse cx="79.5" cy="28.5" rx="5.49999" ry="5.5" />
    </SvgIcon>
);

export default TravelTimeIcon;
